<template>
  <div ref="outer" class="detail-container is-clearfix">
    <div ref="inner" class="detail-wrapper">
      <div v-for="campaign in step.campaigns" class="detail">
        <div class="has-text-weight-bold mb-50">
          <div class="color-indicator" :style="{ background: campaign.color }"></div>
          {{ campaign.label }}
        </div>
        <div class="mb-25">{{ campaign.value }} Records ({{ getPercent(campaign.value, step.value) }})</div>
        <div v-if="campaign.value > 0">${{ campaign.costPer }} cost per {{ step.costPerLabel }}</div>
        <div v-else>--</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: Object,
  },
  methods: {
    getPercent(val, total, isFloor) {
      const percent = (val / (total / 100));

      if (total === 0) {
        return '0%';
      }

      if (isFloor) {
        return (Math.floor((percent + Number.EPSILON) * 100) / 100) + '%';
      } else {
        return (Math.round((percent + Number.EPSILON) * 100) / 100) + '%';
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.detail-container {
  position: relative;
  background: rgba(255, 255, 255, 0.8);
  height: calc(100% - 20px);
  width: calc(100% - 70px);
  margin: 0 auto;
  top: 50%;
  transform: translate(0, -50%);
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  transition: 0.3s;
  scroll-behavior: smooth;
  @include scrollbar();
  cursor: pointer;
}

.detail-wrapper {
  position: relative;
  top: 50%;
  transform: translate(0, -50%);
  text-align: center;
  width: max-content;
  min-width: 100%;
}

.detail {
  width: 175px;
  text-align: center;
  display: inline-block;
  white-space: initial;
  padding: 0 5px;
  font-size: 11px;
}

.color-indicator {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 4px;
}
</style>
